import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Box, Skeleton, Stack } from '@mui/material'
import { get } from 'store/settings/marking-period'
import { useSession } from 'components/Providers'
import Header from 'components/Header'
import MarkingPeriodEditForm from './Form'

function FormSkeleton() {
  return (
    <Box>
      <Header title="Edit Marking Period" small close="." />
      <Stack spacing={2} sx={{ p: 2 }}>
        <Skeleton variant="rounded" height={40} />
        <Skeleton variant="rounded" height={40} />
        <Skeleton variant="rounded" height={40} />
      </Stack>
    </Box>
  )
}

export default function MarkingPeriodFormIndex() {
  const dispatch = useDispatch()
  const { academicYear } = useSession()
  const { id } = useParams()
  const [markingPeriod, setMarkingPeriod] = useState(null)

  useEffect(() => {
    if (id && academicYear?.id) {
      dispatch(get({ academicYearId: academicYear.id, id })).then(res => setMarkingPeriod(res.payload))
    } else {
      setMarkingPeriod(null)
    }
  }, [id, academicYear?.id])

  return markingPeriod ? <MarkingPeriodEditForm markingPeriod={markingPeriod} /> : <FormSkeleton />
}
